/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppMessageByTemplateToken} from '../api'

 export const useQueryGetAppMessageByTemplateToken = createReactQueryHook('getAppMessageByTemplateToken', getAppMessageByTemplateToken)
